import emailPassword from './EmailPassword/index';
import oAuth from './OAuth';

const methods = {
  'Email & Password': emailPassword,
  'OAuth 2.0': oAuth
};

export default methods;
